export class TextSizePerformShrink {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get performer() {
        return this.parent;
    }
    get allBorders() {
        return this.performer.borders;
    }
    get groupItems() {
        return this.performer.groupItems;
    }
    get hasReachedMinimumFontSize() {
        return this.groupItems.currentScaledFontSize <= this.groupItems.minFontSize;
    }
    get isAboveMaximumFontsize() {
        // if (!this.performer.group.globalTextsizer.isMasterSizer) return false;   enable later for performance improvement?
        return this.groupItems.currentScaledFontSize > this.groupItems.maxFontSize;
    }
    shrinkWhileBorderIsExceeded() {
        let shouldStop = false;
        for (let i = 0; i < this.performer.MAX_LOOPS && !this.hasReachedMinimumFontSize && !shouldStop; i++) {
            this.performer.doesExceedBorder = i === 0 ? this.performer.doesExceedBorder : this.allBorders.doesExceedBorder;
            if (this.performer.doesExceedBorder || this.isAboveMaximumFontsize) {
                this.shrinkOneStep();
            }
            else {
                shouldStop = true;
            }
        }
    }
    shrinkOneStep() {
        this.allBorders.saveCompareState();
        this.groupItems.decreaseFontSize();
    }
}
